const DEFAULT_API_URL = 'https://maaliniyohabeensystem.taamsolutions.net/api';

let config = null;
let loadPromise = null;
let apiBase = null;

export async function loadRuntimeConfig() {
  if (config) return config;
  if (loadPromise) return loadPromise;

  loadPromise = (async () => {
    try {
      const base = process.env.PUBLIC_URL || '';
      const res = await fetch(`${base}/runtime-config.json`, { cache: 'no-store' });
      if (res.ok) {
        config = await res.json();
      } else {
        config = {};
      }
    } catch {
      config = {};
    }
    return config;
  })();

  return loadPromise;
}

function getConfiguredApiBase() {
  const fromRuntime = config?.apiUrl;
  const fromEnv = process.env.REACT_APP_API_URL;
  const url = fromRuntime || fromEnv || DEFAULT_API_URL;
  return String(url).replace(/\/$/, '');
}

/** Resolve the remote API base URL from runtime-config.json or env. */
export async function resolveApiBase(force = false) {
  if (force) {
    config = null;
    loadPromise = null;
    apiBase = null;
    await loadRuntimeConfig();
  }

  if (!apiBase) {
    apiBase = getConfiguredApiBase();
  }

  return apiBase;
}

export function getApiBase() {
  return apiBase || getConfiguredApiBase();
}

export function resetApiBase() {
  apiBase = null;
  config = null;
  loadPromise = null;
}
